import { captureAuthCallbackParams } from '@/Domain/utils/authCallbackParams';
import {
  clearPendingVerificationEmailOnActivation,
  consumePendingVerificationEmailFromUrl,
} from '@/Domain/utils/pendingVerificationEmail';

consumePendingVerificationEmailFromUrl();
clearPendingVerificationEmailOnActivation();
captureAuthCallbackParams();
